import { List, ListItem, Stack } from '@mui/material';
import React from 'react';
import Icon from '@mdi/react';
import { mdiArrowRight, mdiCommentTextOutline, mdiHistory } from '@mdi/js';
import DateTag from '../../TextBlocks/DateTag';
import GroupedAvatars from '../../GroupedAvatars/GroupedAvatars';
import MainField from '../../TextBlocks/MainField';
import { vars } from '../../../../Theme';
import { genObjectId } from '../../../../util/HashUtils';
import { parseDate } from '../../../../util/DateUtils';

const forwardIcon = 'M21,12L14,5V9C7,10 4,15 3,20C5.5,16.5 9,14.9 14,14.9V19L21,12Z';
const itemSx = { p: 0, my: 1, borderBottom: '1px solid black' };

export default ({ data }: { data: IActivityLogWorkflow[] }) => (
    <List sx={{ p: 0, overflowY: 'auto' }}>
        {(data ?? []).map(item => (
            <ListItem key={genObjectId(item)} sx={itemSx}>
                <Stack spacing={1} width='100%'>
                    <Stack spacing={1} direction='row'>
                        <Icon path={forwardIcon} color='#1976D2' size={1} />
                        <MainField text={item.SignStatus} />
                        <DateTag
                            date={parseDate(item.EventTime, 'DD.MM.YYYY HH:mm:ss').toISOString()}
                            showTooltipWithTime={true}
                        />
                    </Stack>
                    <Stack pl={1}>
                        <GroupedAvatars data={item.Username} />
                    </Stack>
                    <Stack direction='row' spacing={2}>
                        <Icon path={mdiHistory} size={1} color={vars.font} />
                        <span>{item.TaskCurrent}</span>
                    </Stack>
                    <Stack direction='row' spacing={2}>
                        <Icon path={mdiArrowRight} size={1} color={vars.font} />
                        <span>{item.TaskTarget}</span>
                    </Stack>
                    {item.Comment && (
                        <Stack direction='row' spacing={2}>
                            <Icon path={mdiCommentTextOutline} size={1} color={vars.font} />
                            <span>{item.Comment}</span>
                        </Stack>
                    )}
                </Stack>
            </ListItem>
        ))}
    </List>
);

export interface IActivityLogWorkflow {
    EventTime: string; // "20.03.2024 13:40:12",
    Username: string; // "Max Mustermann - EPLASS GmbH",
    Comment: string; // "Test comment",
    SignStatus: string; // "freigegeben",
    TaskCurrent: string; // "Datenpool - Import",
    TaskTarget: string; // "01 Creator - starting Task"
}
